function checkEmailFormat(input){
    let regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(input);              
}
function debounce(func, timeout = 700){
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }
function ShowError(input,errorElement){
input.style = "background-color: rgb(240, 192, 184); border:1px solid red";
errorElement.style="color:red; display:inline;";
}
function HideErrorAndBackground(input,errorElement){
input.style = "background-color: white";
errorElement.style="display:none;";
}
function HideMessage(msgElement){
  if(msgElement){
    msgElement.style="display:none";
  }
}
function ClearInputElement(input){
    if(input){
        input.style="background-color: white";
        input.value = "";
    }
}

function CheckIfFieldIsEmpty(input){
  return input.value.trim() == '';
}
function CheckIfLengthLessThanFive(input){
  return input.value.length < 5;
}
function CheckFieldIsTooShort(input,errorMessageElement){
        if(CheckIfLengthLessThanFive(input))
        {
          ShowError(input,errorMessageElement);
        }
        else{
            HideErrorAndBackground(input,errorMessageElement);
        }
    }
function CheckIfFieldIsEmptyAndSetError(input,errorMessageElement){
    if(CheckIfFieldIsEmpty(input))
    {
      ShowError(input,errorMessageElement);
    }
    else{
        HideErrorAndBackground(input,errorMessageElement);
    }
}
function CheckEmailAndSetError(input,errorElement){
    if(!checkEmailFormat(input.value)){
        ShowError(input,errorElement);
      }
      else{
        HideErrorAndBackground(input,errorElement);
      }
}
